if ( typeof ProductImageZoom !== 'function' ) {

	/* Azeo : injecte le CSS de la lightbox + du curseur (evite de toucher aux gros fichiers CSS du theme) */
	if ( ! document.getElementById('azeo-product-lightbox-style') ) {
		const azeoStyle = document.createElement('style');
		azeoStyle.id = 'azeo-product-lightbox-style';
		azeoStyle.textContent = `
.product-gallery-item__zoom{position:absolute!important;top:0!important;right:0!important;bottom:0!important;left:0!important;width:100%!important;height:100%!important;margin:0!important;z-index:20;opacity:1!important;background:transparent!important;border-radius:0!important;padding:0!important;}
.no-touchevents .product-gallery-item__zoom:hover{opacity:1!important;background:transparent!important;}
.no-touchevents .product-gallery-item[data-product-media-type="image"]{cursor:none;}
.product-gallery-cursor{position:fixed;top:0;left:0;width:52px;height:52px;border-radius:50%;background:rgba(255,255,255,.55);pointer-events:none;z-index:9999;display:flex;align-items:center;justify-content:center;opacity:0;transform:translate3d(-999px,-999px,0);transition:opacity 150ms ease,transform 90ms cubic-bezier(.2,.8,.2,1);will-change:transform,opacity;box-shadow:0 2px 10px rgba(0,0,0,.12);}
.product-gallery-cursor.is-visible{opacity:1;}
.product-gallery-cursor svg{width:16px;height:16px;transition:transform 200ms cubic-bezier(.34,1.56,.64,1);}
@keyframes azeoCursorPulse{0%{transform:scale(1);}45%{transform:scale(.55);}100%{transform:scale(1);}}
.product-gallery-cursor.is-clicking svg{animation:azeoCursorPulse 320ms cubic-bezier(.34,1.56,.64,1);}
.product-gallery-cursor.is-clicking{background:rgba(255,255,255,.9);transition:background 100ms ease,opacity 150ms ease;}
.product-lightbox{position:fixed;top:0;left:0;width:100%;height:100vh;background:#fff;z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;opacity:0;visibility:hidden;transition:opacity 280ms ease;}
.product-lightbox.is-open{opacity:1;visibility:visible;}
.product-lightbox__close{position:absolute;top:1.5625rem;right:1.5625rem;z-index:3;width:2.75rem;height:2.75rem;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;background:#fff;border:1px solid #dcdcdc;transition:background 150ms ease,border-color 150ms ease;}
.no-touchevents .product-lightbox__close:hover{background:#F2F1E4;border-color:#c9c2ae;}
.product-lightbox__close:active{transform:scale(.92);}
.product-lightbox__close svg{width:16px;height:16px;display:block;}
.product-lightbox__stage{position:relative;width:100%;max-width:1000px;flex:1 1 auto;display:flex;align-items:center;justify-content:center;padding:2rem 4.5rem;min-height:0;}
.product-lightbox__image-holder{position:relative;width:100%;height:70vh;max-height:70vh;perspective:1400px;transform-style:preserve-3d;opacity:0;transform:scale(.92);transition:transform 380ms cubic-bezier(.16,1,.3,1),opacity 280ms ease;}
.product-lightbox.is-open .product-lightbox__image-holder{transform:none;opacity:1;}
/* r3 16/10 netteté : centrage sans translate(-50%) (demi-pixels = image floue), pas de will-change permanent (Chrome gardait le rendu à l'échelle .78 de l'animation), aucune transformation au repos */
.product-lightbox__image{position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;border-radius:.3125rem;opacity:0;box-shadow:0 25px 60px rgba(0,0,0,.16);transform:none;transition:transform 480ms cubic-bezier(.22,.68,0,1.01),opacity 340ms ease;}
.product-lightbox__image.is-active{opacity:1;transform:none;}
.product-lightbox__image.from-next{opacity:0;transform:translate3d(110px,0,-340px) rotateY(-16deg) scale(.78);}
.product-lightbox__image.from-prev{opacity:0;transform:translate3d(-110px,0,-340px) rotateY(16deg) scale(.78);}
.product-lightbox__image.is-outgoing-next{opacity:0;transform:translate3d(-110px,0,-340px) rotateY(16deg) scale(.78);}
.product-lightbox__image.is-outgoing-prev{opacity:0;transform:translate3d(110px,0,-340px) rotateY(-16deg) scale(.78);}
.product-lightbox__arrow{position:absolute;top:50%;transform:translateY(-50%);width:2.75rem;height:2.75rem;border-radius:50%;background:#fff;border:1px solid #dcdcdc;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:3;transition:background 150ms ease,border-color 150ms ease;}
.no-touchevents .product-lightbox__arrow:hover{background:#F2F1E4;border-color:#c9c2ae;}
.product-lightbox__arrow:active{transform:translateY(-50%) scale(.92);}
.product-lightbox__arrow svg{width:16px;height:16px;display:block;}
.product-lightbox__arrow--prev{left:.5rem;}
.product-lightbox__arrow--next{right:.5rem;}
@media screen and (min-width:768px){.product-lightbox__arrow--prev{left:1.5rem;}.product-lightbox__arrow--next{right:1.5rem;}}
.product-lightbox__thumbs{flex:0 0 auto;width:100%;max-width:100%;padding:1.25rem 1.25rem 1.5625rem;overflow-x:auto;-ms-overflow-style:none;scrollbar-width:none;border-top:1px solid #ececec;}
.product-lightbox__thumbs::-webkit-scrollbar{display:none;}
.product-lightbox__thumbs-holder{display:flex;gap:.625rem;justify-content:center;width:max-content;margin:0 auto;}
.product-lightbox__thumb{flex-shrink:0;width:4.5rem;height:4.5rem;border-radius:.3125rem;overflow:hidden;border:2px solid transparent;opacity:.55;cursor:pointer;transition:all 150ms ease;background-size:cover;background-position:center;background-color:#f5f5f5;}
.product-lightbox__thumb.is-active{opacity:1;border-color:#2E2E2E;transform:scale(1.05);}
.no-touchevents .product-lightbox__thumb:hover{opacity:1;}
@media screen and (max-width:767px){.product-lightbox__stage{padding:1.5rem 1rem;}.product-lightbox__arrow{width:2.375rem;height:2.375rem;}.product-lightbox__arrow svg,.product-lightbox__close svg{width:13px;height:13px;}.product-lightbox__thumb{width:3.5rem;height:3.5rem;}.product-lightbox__image-holder{height:56vh;}}
		`;
		document.head.appendChild(azeoStyle);
	}

	/* Azeo : curseur rond "+" qui suit la souris au survol de la galerie produit */
	class AzeoGalleryCursor {

		constructor(){
			this.el = document.querySelector('.product-gallery-cursor');
			if ( ! this.el ) {
				this.el = document.createElement('div');
				this.el.className = 'product-gallery-cursor';
				this.el.setAttribute('aria-hidden', 'true');
				this.el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5v14M5 12h14" stroke="#000" stroke-width="2" stroke-linecap="round"/></svg>';
				document.body.appendChild(this.el);
			}
			this.visible = false;
			this.onMove = this.onMove.bind(this);
		}

		show(){
			if ( this.visible ) return;
			this.visible = true;
			this.el.classList.add('is-visible');
			window.addEventListener('mousemove', this.onMove, { passive: true });
		}

		hide(){
			if ( ! this.visible ) return;
			this.visible = false;
			this.el.classList.remove('is-visible');
			window.removeEventListener('mousemove', this.onMove);
		}

		pulse(){
			this.el.classList.remove('is-clicking');
			void this.el.offsetWidth;
			this.el.classList.add('is-clicking');
			window.setTimeout(() => this.el.classList.remove('is-clicking'), 340);
		}

		onMove(e){
			this.el.style.transform = 'translate3d(' + (e.clientX - 26) + 'px, ' + (e.clientY - 26) + 'px, 0)';
		}

	}

	window.AzeoGalleryCursor = window.AzeoGalleryCursor || new AzeoGalleryCursor();

	/* Azeo : lightbox plein ecran avec fleches + vignettes + transition 3d empilement */
	class AzeoProductLightbox {

		constructor(){

			this.el = document.getElementById('AzeoProductLightbox');

			if ( ! this.el ) {

				this.el = document.createElement('div');
				this.el.id = 'AzeoProductLightbox';
				this.el.className = 'product-lightbox';
				this.el.setAttribute('role', 'dialog');
				this.el.setAttribute('aria-modal', 'true');
				this.el.setAttribute('aria-label', 'Photos du produit en grand');
				this.el.innerHTML = `
					<button type="button" class="product-lightbox__close" aria-label="Fermer">
						<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6l12 12M18 6L6 18" stroke="#2E2E2E" stroke-width="1.5" stroke-linecap="round"/></svg>
					</button>
					<div class="product-lightbox__stage">
						<button type="button" class="product-lightbox__arrow product-lightbox__arrow--prev" aria-label="Image précédente">
							<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6l-6 6 6 6" stroke="#2E2E2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
						</button>
						<div class="product-lightbox__image-holder"></div>
						<button type="button" class="product-lightbox__arrow product-lightbox__arrow--next" aria-label="Image suivante">
							<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="#2E2E2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
						</button>
					</div>
					<div class="product-lightbox__thumbs">
						<div class="product-lightbox__thumbs-holder"></div>
					</div>
				`;
				document.body.appendChild(this.el);

				this.imageHolder = this.el.querySelector('.product-lightbox__image-holder');
				this.thumbsHolder = this.el.querySelector('.product-lightbox__thumbs-holder');
				this.prevBtn = this.el.querySelector('.product-lightbox__arrow--prev');
				this.nextBtn = this.el.querySelector('.product-lightbox__arrow--next');
				this.closeBtn = this.el.querySelector('.product-lightbox__close');

				this.closeBtn.addEventListener('click', this.close.bind(this));
				this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
				this.nextBtn.addEventListener('click', () => this.go(this.index + 1));

				this.el.addEventListener('click', (e) => {
					if ( e.target === this.el ) this.close();
				});

				window.addEventListener('keydown', (e) => {
					if ( ! this.el.classList.contains('is-open') ) return;
					if ( e.key === 'Escape' ) this.close();
					/* r2 15/10 a11y : focus maintenu dans la visionneuse (dialogue modal) */
					if ( e.key === 'Tab' ) {
						const f = Array.from(this.el.querySelectorAll('button')).filter((b) => b.offsetParent !== null);
						if ( f.length ) {
							const first = f[0], last = f[f.length - 1];
							if ( e.shiftKey && document.activeElement === first ) { e.preventDefault(); last.focus(); }
							else if ( ! e.shiftKey && document.activeElement === last ) { e.preventDefault(); first.focus(); }
							else if ( ! this.el.contains(document.activeElement) ) { e.preventDefault(); first.focus(); }
						}
					}
					if ( e.key === 'ArrowLeft' ) this.go(this.index - 1);
					if ( e.key === 'ArrowRight' ) this.go(this.index + 1);
				});

			} else {
				this.closeBtn = this.el.querySelector('.product-lightbox__close');
				this.imageHolder = this.el.querySelector('.product-lightbox__image-holder');
				this.thumbsHolder = this.el.querySelector('.product-lightbox__thumbs-holder');
				this.prevBtn = this.el.querySelector('.product-lightbox__arrow--prev');
				this.nextBtn = this.el.querySelector('.product-lightbox__arrow--next');
			}

			this.images = [];
			this.index = 0;
			this.currentImgEl = null;

		}

		collect(){
			const nodes = document.querySelectorAll('product-image-zoom[data-image]');
			this.images = Array.from(nodes).map((node) => node.getAttribute('data-image'));
			/* r3 16/10 : vignettes légères (data-thumb), la grande image reste en pleine résolution */
			const thumbs = Array.from(nodes).map((node) => node.getAttribute('data-thumb') || node.getAttribute('data-image'));
			this.thumbsHolder.innerHTML = thumbs.map((src, i) => `<button type="button" class="product-lightbox__thumb" data-lightbox-thumb="${ i }" style="background-image:url('${ src }')" aria-label="Voir l'image ${ i + 1 }"></button>`).join('');
			this.thumbsHolder.querySelectorAll('[data-lightbox-thumb]').forEach((thumb) => {
				thumb.addEventListener('click', () => this.go(parseInt(thumb.getAttribute('data-lightbox-thumb'), 10)));
			});
		}

		open(index){
			/* r2 15/10 a11y (WCAG 2.1.1 / 2.4.3) : mémorise l'ouvreur, focus sur Fermer, focus rendu à la fermeture */
			this.opener = document.activeElement;
			this.collect();
			this.go(index, true);
			document.body.classList.add('product-lightbox-open');
			requestAnimationFrame(() => {
				this.el.classList.add('is-open');
				if ( this.closeBtn ) this.closeBtn.focus();
			});
		}

		close(){
			this.el.classList.remove('is-open');
			document.body.classList.remove('product-lightbox-open');
			if ( this.opener && typeof this.opener.focus === 'function' && document.contains(this.opener) ) this.opener.focus();
			this.opener = null;
		}

		go(index, force){
			if ( this.images.length === 0 ) return;
			if ( index < 0 ) index = 0;
			if ( index > this.images.length - 1 ) index = this.images.length - 1;
			if ( index === this.index && force !== true ) return;

			const direction = force ? 0 : ( index > this.index ? 1 : -1 );
			this.index = index;

			const src = this.images[this.index];
			const outgoing = this.currentImgEl;

			const incoming = document.createElement('img');
			incoming.className = 'product-lightbox__image';
			incoming.alt = '';
			incoming.decoding = 'async';

			incoming.onload = () => {

				this.imageHolder.appendChild(incoming);

				if ( direction === 1 ) incoming.classList.add('from-next');
				else if ( direction === -1 ) incoming.classList.add('from-prev');

				/* force un reflow pour que la transition parte bien de l'etat initial */
				void incoming.offsetWidth;

				requestAnimationFrame(() => {
					incoming.classList.remove('from-next', 'from-prev');
					incoming.classList.add('is-active');

					if ( outgoing ) {
						outgoing.classList.remove('is-active');
						if ( direction === 1 ) outgoing.classList.add('is-outgoing-next');
						else if ( direction === -1 ) outgoing.classList.add('is-outgoing-prev');
						else outgoing.style.opacity = '0';
						window.setTimeout(() => {
							if ( outgoing.parentNode ) outgoing.parentNode.removeChild(outgoing);
						}, 520);
					}
				});

				this.currentImgEl = incoming;

			};

			incoming.src = src;

			this.thumbsHolder.querySelectorAll('[data-lightbox-thumb]').forEach((thumb, i) => {
				thumb.classList.toggle('is-active', i === this.index);
				if ( i === this.index ) {
					thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
				}
			});
		}

	}

	window.AzeoProductLightbox = window.AzeoProductLightbox || new AzeoProductLightbox();

	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			this.addEventListener('click', (e) => {
				e.preventDefault();
				window.AzeoGalleryCursor.pulse();
				const index = parseInt(this.getAttribute('data-index'), 10) || 0;
				window.setTimeout(() => window.AzeoProductLightbox.open(index), 90);
			});

			/* r2 15/10 a11y (WCAG 2.1.1) : agrandissement accessible au clavier (Entrée ou Espace) */
			this.addEventListener('keydown', (e) => {
				if ( e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' ) {
					e.preventDefault();
					const index = parseInt(this.getAttribute('data-index'), 10) || 0;
					window.AzeoProductLightbox.open(index);
				}
			});

			if ( ! ('ontouchstart' in window) ) {
				this.addEventListener('mouseenter', () => window.AzeoGalleryCursor.show());
				this.addEventListener('mouseleave', () => window.AzeoGalleryCursor.hide());
			}

		}

	}

  if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}